import { render, staticRenderFns } from "./events-box.vue?vue&type=template&id=4a2d24f6"
import script from "./events-box.vue?vue&type=script&lang=js"
export * from "./events-box.vue?vue&type=script&lang=js"
import style0 from "./events-box.vue?vue&type=style&index=0&id=4a2d24f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports